/***
 *
 *   TICKET CATEGORY SETTINGS LAYOUT
 *   Phase 6 — reference CategorySettingsLayout chrome: color-bar header +
 *   underline SubNav + body. Routes stay under /app/tickets/category/:id.
 *
 **********/

import React, { useEffect, cloneElement } from 'react';
import { SubNav, useBreadcrumbsContext, Skeleton } from 'components/lib';
import { _t } from 'app/translations';
import { useParams } from 'react-router-dom';
import { useLiveQuery } from 'components/hooks/websocket';
import { useProjectContext } from 'components/lib';
import Style from './ticketsCategory.tailwind';

const TicketsCategoryLayout = (props) => {
    const { id } = useParams();
    const { pushParams, setForcedActiveUrl } = useBreadcrumbsContext();
    const { selectedProject } = useProjectContext();

    const categoryData = useLiveQuery(
        'ticket_category',
        { id, project_id: selectedProject?.id },
        {
            enabled: !!selectedProject?.id && !!id,
        },
    );

    const data = categoryData?.data ? categoryData.data[0] : null;
    const baseUrl = `/app/tickets/category/${id}`;

    const unassigned = data?.status_template?.find((s) => s.key === 'unassigned');
    const containUnassigned = (unassigned?.statuses?.length || 0) > 0;
    const visibleStatuses =
        data?.status_template?.filter((s) => !s.hidden && s.key !== 'unassigned') || [];
    const accentColor = visibleStatuses[0]?.color || data?.status_template?.[0]?.color || '#6366F1';

    const items = [
        { link: `${baseUrl}`, label: _t('general'), permission: 'admin', exact: true },
        {
            link: `${baseUrl}/status`,
            label: _t('status.multiple'),
            permission: 'user',
            ...(containUnassigned
                ? { alert: { message: _t('ticket.category.status.unassignedAlert') } }
                : {}),
        },
    ];

    useEffect(() => {
        if (!data?.name) return;
        pushParams(
            {
                id: data.name,
            },
            'id',
        );
        setForcedActiveUrl(`/app/tickets/category/${id}`);
    }, [data?.name]);

    if (!data && (categoryData.isLoading || categoryData.status === 'loading')) {
        return (
            <div className={Style.shell}>
                <Skeleton className="h-10 w-64" />
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-64 w-full" />
            </div>
        );
    }

    return (
        <div className={Style.shell}>
            <div className={Style.header}>
                <div className={Style.accent} style={{ backgroundColor: accentColor }} />
                <div className="min-w-0">
                    <h2 className={Style.title}>{data?.name || '—'}</h2>
                    <p className={Style.meta}>
                        {visibleStatuses.length} {_t('status.multiple').toLowerCase()}
                    </p>
                </div>
            </div>

            <SubNav items={items} className={Style.tabs} />

            <div className={Style.body}>{cloneElement(props.children, { data: data || {} })}</div>
        </div>
    );
};

export default TicketsCategoryLayout;
